import NotFoundIndex from '@/Libs/Pages/Public/Other/NotFoundIndex.vue'
import UnauthorizedIndex from '@/Libs/Pages/Public/Other/UnauthorizedIndex.vue'
import Auth from "@/Libs/Route/Public/Auth"

import Transaction from "@/Libs/Route/Panel/Transaction"
import Service from "@/Libs/Route/Panel/Service"
import Restaurant from "@/Libs/Route/Panel/Restaurant"
import Reservation from "@/Libs/Route/Panel/Reservation"
import Report from "@/Libs/Route/Panel/Report"
import MasterData from "@/Libs/Route/Panel/MasterData"
import Config from "@/Libs/Route/Panel/Config"
import Other from "@/Libs/Route/Panel/Other"

import Employee from "@/Libs/Route/Public/Employee.js"

var defaultRoute = [
    {
        name: '/',
        path: '/',
        redirect: '/dashboard',
    },
    {
        name: 'unauthorized',
        path: '/unauthorized',
        component: UnauthorizedIndex,
        title: 'basic.title.unauthorized',
    },
    {
        path: '/:pathMatch(.*)*',
        component: NotFoundIndex
    }
];

var routes = defaultRoute.concat(Auth, Transaction, Service, Restaurant, Report, Other, Employee, MasterData, Reservation, Config);

export default routes;